import React, { useState, Suspense } from 'react';
import AdminTabsComponent from './AdminTabsComponent.component';
import {
  LeftAdmin,
  RightAdmin,
  TopLeftAdmin,
  BottomLeftAdmin,
  AdminContainer,
  AdminTable,
} from './AdminStyles.styles';
import { AuthCheckAdmin } from '../../Utils/AuthCheck/AdminCheck.auth';
import AdminSideMenu from './AdminSideMenu.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import { useMediaQuery } from 'react-responsive';

const CompaniesTab = React.lazy(
  () => import('./Companies/CompaniesTabComponent.component')
);
const CoursesTab = React.lazy(
  () => import('./Courses/CoursesTabComponent.component')
);
const UsersTab = React.lazy(() => import('./Users/UserTabComponent.component'));
const NewsletterTab = React.lazy(
  () => import('./Newsletters/NewsletterTab.component')
);

const Admin = () => {
  const [showCompanies, setShowCompanies] = useState(true);
  const [showCourses, setShowCourses] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [showNewsletters, setShowNewsletters] = useState(false);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  return (
    <AuthCheckAdmin>
      <HelmetHelper
        title="Admin Home"
        description="Admin homepage for creating, updating and deleting"
      />
      <AdminContainer>
        <LeftAdmin>
          <TopLeftAdmin>
            <h2>Admin Dashboard</h2>
          </TopLeftAdmin>
          <BottomLeftAdmin>
            <AdminSideMenu />
          </BottomLeftAdmin>
        </LeftAdmin>
        {!isMobile && (
          <RightAdmin>
            <AdminTabsComponent
              setShowCompanies={setShowCompanies}
              showCompanies={showCompanies}
              setShowCourses={setShowCourses}
              showCourses={showCourses}
              setShowUsers={setShowUsers}
              showUsers={showUsers}
              setShowNewsletters={setShowNewsletters}
              showNewsletters={showNewsletters}
            />
            <AdminTable>
              <Suspense fallback={<p>Loading admin components...</p>}>
                {showCompanies && <CompaniesTab />}
                {showCourses && <CoursesTab />}
                {showUsers && <UsersTab />}
                {showNewsletters && <NewsletterTab />}
              </Suspense>
            </AdminTable>
          </RightAdmin>
        )}
      </AdminContainer>
    </AuthCheckAdmin>
  );
};

export default Admin;
